import * as React from 'react';

import { MoneyInput } from '@rematter/frontend-lib-api-client';
import { cn, Money } from '@rematter/ui-web';

export interface ComputedPriceCellProps {
  value: MoneyInput | null;
  showNegative?: boolean;
  subtitle?: string;
  className?: string;
}

export const ComputedPriceCell: React.FC<ComputedPriceCellProps> = ({
  value,
  showNegative,
  subtitle,
  className,
}) => {
  const isNegative = showNegative && value && value.amount < 0;

  return (
    <div
      className={cn(
        '@ComputedPriceCell',
        'h-10 flex-col content-center rounded-md bg-neutral/5 px-3',
        isNegative && 'text-failure',
        className,
      )}
    >
      <Money {...value} className="flex w-full justify-between gap-1 text-sm" />
      {subtitle && (
        <div
          className={cn(
            'text-end text-xs font-normal text-neutral/60',
            isNegative && 'text-failure',
          )}
        >
          {subtitle}
        </div>
      )}
    </div>
  );
};
